import { render, staticRenderFns } from "./CreateOrUpdateFacility.vue?vue&type=template&id=134f2ce1"
import script from "./CreateOrUpdateFacility.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports